import React, { useState, useRef, useEffect } from "react";
import QRCodeStyling from "qr-code-styling";
import { RiResetLeftFill } from "react-icons/ri";
import { FaChevronDown, FaPlus } from "react-icons/fa";
import { MdOutlineImageNotSupported } from "react-icons/md";
import logomyH from '../assets/images/logomyH.png';
import bg from "../assets/images/bg.webp";
import { logoOptions } from '../components/donvi';

const pageStyles = {
    fontFamily: "-apple-system, Roboto, sans-serif, serif",
    backgroundImage: `url(${bg})`, 
    minHeight:"90vh", 
    backgroundPosition: 'center', 
    backgroundSize: 'cover'
};

export default function CreateQR() {
    const [isformatStyleQR, setIsformatStyleQR] = useState(false);
    const [isformatColorQR, setIsformatColorQR] = useState(false);
    const [isformatLogoQR, setIsformatLogoQR] = useState(false);

    const handleFormatStyleQR = () => setIsformatStyleQR(!isformatStyleQR);
    const handleFormatColorQR = () => setIsformatColorQR(!isformatColorQR);

    const valueSelectStyleQR = [
    { value: "square", label: "Vuông",},
    { value: "classy", label: "Thanh lịch",},
    { value: "classy-rounded", label: "Bo tròn thanh lịch",},
    { value: "dots", label: "Nhiều chấm",},
    { value: "dot", label: "Chấm",},
    { value: "rounded", label: "Bo tròn",},
    { value: "extra-rounded", label: "Bo tròn đặc biệt",},
    ]


    const fileInputRef = useRef(null);
      const [settings, setSettings] = useState(() => {
        const savedSettings = localStorage.getItem("qrSettings");
        return savedSettings
          ? JSON.parse(savedSettings)
          : {
              width: 500,
              height: 500,
              type: "svg",
              shape: "square",
              data: window.location.href,
              image: logomyH,
              margin: 1,
              dotsOptionsColor: "#000000",
              dotsOptionsType: "dots",
              backgroundOptionsColor: "#ffffff",
              cornersSquareOptionsType: "extra-rounded",
              cornersSquareOptionsColor: "#000000",
              cornersDotOptionsType: "extra-rounded",
              cornersDotOptionsColor: "#000000",
              imageOptions_crossOrigin: "anonymous",
              imageOptions_margin: 1,
            };
      });
      

  const qrRef = useRef(null);
  const qrCode = useRef(new QRCodeStyling());

  useEffect(() => {
    updateQRCode();
  }, [settings]);

  const updateQRCode = () => {
    qrCode.current.update({
      width: settings.width,
      height: settings.width,
      type: settings.type,
      shape: settings.shape,
      image: settings.image,
      margin: settings.margin,
      data: settings.data,
      dotsOptions: { color: settings.dotsOptionsColor, type: settings.dotsOptionsType },
      backgroundOptions: { color: settings.backgroundOptionsColor },
      cornersSquareOptions: { type: settings.cornersSquareOptionsType, color: settings.cornersSquareOptionsColor },
      cornersDotOptions: { type: settings.cornersDotOptionsType, color: settings.cornersDotOptionsColor },
      imageOptions: { crossOrigin: "anonymous", margin: settings.imageOptions_margin },
    });
    qrRef.current.innerHTML = "";
    qrCode.current.append(qrRef.current);
  };

  const handleChange = (field, value) => {
    const newSettings = { ...settings, [field]: value };
    setSettings(newSettings);
    localStorage.setItem("qrSettings", JSON.stringify(newSettings)); // Lưu vào localStorage
  };

  const handleDownloadQR = async () => {
    const blob = await qrCode.current.getRawData("png");
    const link = document.createElement("a");
    link.href = URL.createObjectURL(blob);
    link.download = "QRCode.png";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <div style={pageStyles}>
      <div className="p-6 max-w-6xl mx-auto flex flex-col md:flex-row gap-6">
        {/* Cột bên trái - Chỉnh thông tin */}
        <div className="md:w-1/2 bg-white p-6 rounded-lg shadow-md">
          <h2 className="text-2xl font-bold text-center mb-4 text-[#0266B4]">Tạo mã QR</h2>
          <div>
            <label>Nội dung</label>
            <input type="text" placeholder="Nhập nội dung..." value={settings.data} onChange={(e) => handleChange("data" , e.target.value)} className="w-full p-2 border border-gray-300 rounded"/>
          </div>
          <button onClick={()=> setIsformatLogoQR(!isformatLogoQR)} className="flex justify-between items-center w-full mt-4 px-4 py-2 bg-[#0266B4] text-white rounded hover:bg-[#125e99] my-2">
          <p>Logo QR</p>
          <FaChevronDown className={`transition-transform duration-300 ${isformatLogoQR ? 'rotate-360' : 'rotate-90'}`} />
          </button>
          {isformatLogoQR && (
                      <div className="grid grid-cols-7 gap-2 p-2 rounded my-2">
            {logoOptions.map((logo, index) => (
              <button
                key={index}
                type="button"
                onClick={() => handleChange("image", logo)}
                className={`
                  flex items-center justify-center aspect-square w-12 h-12 rounded border-2
                  transition-all duration-200
                  ${settings.image === logo ? 'border-[#4AB253] ring-2 ring-[#4AB253]' : 'border-gray-200'}
                  hover:scale-105 hover:border-[#4AB253] bg-white
                `}
                style={{ padding: 0 }}
              >
                <img
                  src={logo}
                  alt="Logo"
                  className="object-contain w-8 h-8"
                  draggable={false}
                />
              </button>
            ))}
            <button
              type="button"
              onClick={() => handleChange("image", null)}
              className={`
                flex items-center justify-center aspect-square w-12 h-12 rounded border-2
                transition-all duration-200
                ${settings.image === null ? 'border-red-500 ring-2 ring-red-400 bg-red-50' : 'border-gray-200'}
                hover:scale-105 hover:border-red-400 bg-white
              `}
            >
              <MdOutlineImageNotSupported className="text-xl text-red-500" />
            </button>
            <button
              type="button"
              onClick={() => fileInputRef.current.click()}
              className={`
                flex items-center justify-center aspect-square w-12 h-12 rounded border-2 border-dashed
                transition-all duration-200
                hover:scale-105 hover:border-green-500 bg-white
              `}
            >
              <FaPlus size={18} className="text-[#4AB253]" />
            </button>
            <input
              type="file"
              ref={fileInputRef}
              accept="image/*"
              onChange={(e) => handleChange("image", URL.createObjectURL(e.target.files[0]))}
              className="hidden"
            />
          </div>
          )}
          <button onClick={handleFormatStyleQR} className="flex justify-between items-center w-full mt-4 px-4 py-2 bg-[#0266B4] text-white rounded hover:bg-[#125e99] my-2">
            <p>Định dạng QR</p>
            <FaChevronDown className={`transition-transform duration-300 ${isformatStyleQR ? 'rotate-360' : 'rotate-90'}`} />
            </button>
            {isformatStyleQR && (
              <div>
                <div>
                  <label>Hình dạng</label>
                  <select value={settings.shape} onChange={(e) => handleChange("shape", e.target.value)} className="w-full p-2 border border-gray-300 rounded">
                    <option value="square">Vuông</option>
                    <option value="circle">Tròn</option>
                  </select>
                </div>
                <div>
                  <label>Kiểu chấm _ loại</label>
                  <select value={settings.dotsOptionsType} onChange={(e) => handleChange("dotsOptionsType", e.target.value)} className="w-full p-2 border border-gray-300 rounded">
                    {valueSelectStyleQR.map((item) => ( <option value={item.value}>{item.label}</option> ))}
                  </select>
                </div>

                <div>
                  <label>Bo gốc _ loại</label>
                  <select value={settings.cornersSquareOptionsType} onChange={(e) => handleChange("cornersSquareOptionsType", e.target.value)} className="w-full p-2 border border-gray-300 rounded">
                    {valueSelectStyleQR.map((item) => ( <option value={item.value}>{item.label}</option> ))}
                  </select>
                </div>

                <div>
                  <label>Chấm gốc _ loại</label>
                  <select value={settings.cornersDotOptionsType} onChange={(e) => handleChange("cornersDotOptionsType", e.target.value)} className="w-full p-2 border border-gray-300 rounded">
                    {valueSelectStyleQR.map((item) => ( <option value={item.value}>{item.label}</option> ))}
                  </select>
                </div>
                <div>
                  <label>Kích thước</label>
                  <div className="flex w-full p-2 border border-gray-300 rounded">
                      <p className="w-full">{settings.width}x{settings.width}</p>
                      <input type="range" min="100" max="1000" step={10} placeholder="Nhập kích thước..." value={settings.width} onChange={(e) => handleChange("width", e.target.value)} className="w-full"/>
                  </div>
                </div>
                <div>
                  <label>Lề logo</label>
                  <input type="text" placeholder="Nhập logo lề..." value={settings.imageOptions_margin} onChange={(e) => handleChange("imageOptions_margin", e.target.value)} className="w-full p-2 border border-gray-300 rounded"/>
                </div>
                <div>
                  <label>Lề QR</label>
                  <input type="text" placeholder="Nhập QR lề..." value={settings.margin} onChange={(e) => handleChange("margin", e.target.value)} className="w-full p-2 border border-gray-300 rounded"/>
                </div>
              </div>
            )}
          <button onClick={handleFormatColorQR} className="flex justify-between items-center w-full mt-4 px-4 py-2 bg-[#0266B4] text-white rounded hover:bg-[#125e99] my-2">
            <p>Định dạng màu QR</p>
            <FaChevronDown className={`transition-transform duration-300 ${isformatColorQR ? 'rotate-360' : 'rotate-90'}`} />
          </button>
            {isformatColorQR && (
              <div>
                <div>
                    <label>Kiểu chấm</label>
                    <div className="flex gap-2">
                      <input type="color" placeholder="Chọn màu sắc..." value={settings.dotsOptionsColor} onChange={(e) => handleChange("dotsOptionsColor", e.target.value)} className="w-full p-2 h-10 border border-gray-300 rounded"/>
                      <input type="text" placeholder="Nhập màu sắc..." value={settings.dotsOptionsColor} onChange={(e) => handleChange("dotsOptionsColor", e.target.value)} className="w-full p-2 border border-gray-300 rounded"/>
                    </div>
                  </div>
                  <div>
                    <label>Màu nền</label>
                    <div className="flex gap-2">
                      <input type="color" placeholder="Chọn màu nền..." value={settings.backgroundOptionsColor} onChange={(e) => handleChange("backgroundOptionsColor", e.target.value)} className="w-full p-2 h-10 border border-gray-300 rounded"/>
                      <input type="text" placeholder="Nhập màu nền..." value={settings.backgroundOptionsColor} onChange={(e) => handleChange("backgroundOptionsColor", e.target.value)} className="w-full p-2 border border-gray-300 rounded"/>
                    </div>
                  </div>
                  <div>
                    <label>Bo gốc</label>
                    <div className="flex gap-2">
                      <input type="color" placeholder="Chọn bo gốc màu sắc..." value={settings.cornersSquareOptionsColor} onChange={(e) => handleChange("cornersSquareOptionsColor", e.target.value)} className="w-full p-2 h-10 border border-gray-300 rounded"/>
                      <input type="text" placeholder="Nhập bo gốc màu sắc..." value={settings.cornersSquareOptionsColor} onChange={(e) => handleChange("cornersSquareOptionsColor", e.target.value)} className="w-full p-2 border border-gray-300 rounded"/>
                    </div>
                  </div>
                  <div>
                        <label>Chấm gốc</label>
                        <div className="flex gap-2">
                          <input type="color" placeholder="Chọn chấm gốc màu..." value={settings.cornersDotOptionsColor} onChange={(e) => handleChange("cornersDotOptionsColor", e.target.value)} className="w-full p-2 h-10 border border-gray-300 rounded"/>
                          <input type="text" placeholder="Nhập chấm gốc màu..." value={settings.cornersDotOptionsColor} onChange={(e) => handleChange("cornersDotOptionsColor", e.target.value)} className="w-full p-2 border border-gray-300 rounded"/>
                        </div>
                  </div>
    
              </div>
            )}
          <div className="flex justify-end">
            <button onClick={()=>{localStorage.clear("qrSettings"); window.location.reload();}} className="mt-4 px-4 py-2 bg-amber-500 hover:bg-amber-600 text-white rounded"><RiResetLeftFill/></button>
          </div>
        </div>

        {/* Cột bên phải - Hiển thị QR */}
        <div className="md:w-1/2 flex flex-col items-center bg-white p-6 rounded-lg shadow-md">
          <h2 className="text-2xl font-bold mb-4">Mã QR</h2>
          <div ref={qrRef} className="p-4 flex items-center justify-center" style={{ width: `${settings.width}px`, height: `${settings.height}px`, maxWidth: "100%", maxHeight: "100%", overflow: "hidden" }}></div>
          <button
            onClick={handleDownloadQR}
            className="mt-4 px-4 py-2 bg-[#4AB253] text-white rounded hover:bg-[#44a74c]"
          >
            Tải xuống QR
          </button>
        </div>
      </div>
    </div>
  );
}
